/**
 * A · B · C 병렬 카드 row (v3).
 * - dimIds: dim 처리할 step id 목록
 * - hideIds: 필터 모드에서 완전히 숨길 step id 목록
 * - onClickStep: 클릭 가능 카드(detail 있음)의 step id 콜백
 */
import { StepCard } from './StepCard';
import type { Step } from './steps';

interface Props {
  steps: [Step, Step, Step];
  dimIds: string[];
  hideIds?: string[];
  onClickStep?: (id: string) => void;
}

export function ParallelRow({ steps, dimIds, hideIds = [], onClickStep }: Props) {
  // 숨겨진 카드가 있을 때 레이아웃 조정
  const visibleSteps = steps.filter((s) => !hideIds.includes(s.id));

  if (visibleSteps.length === 0) return null;

  return (
    <div
      className={[
        'grid gap-3',
        visibleSteps.length === 3
          ? 'grid-cols-3'
          : visibleSteps.length === 2
          ? 'grid-cols-2'
          : 'grid-cols-1 max-w-sm mx-auto',
      ].join(' ')}
    >
      {visibleSteps.map((step) => (
        <StepCard
          key={step.id}
          step={step}
          dim={dimIds.includes(step.id)}
          onClick={step.detail && onClickStep ? () => onClickStep(step.id) : undefined}
        />
      ))}
    </div>
  );
}
